<template>
  <common-dialog
    ref="dialog"
    title="Modify Pallet"
    :inputs-map="inputsMap"
    :input-value-change="valueChange"
    :save-cb="save"
    :width="50"
    :reset-inputs="resetInputs"
  />
</template>
<script>
// others
import isEmpty from 'lodash/isEmpty'
import get from 'lodash/get'
import cloneDeep from 'lodash/cloneDeep'
// models
import { PalletInfoModifyForm } from '@/core/models/pallet'
// mixin
import { dialogMixin } from '@/core/mixin/dialog'
// components
import CommonDialog from '@/components/common/CommonDialog.vue'
// api
import { modifyPallet } from '@/api/pallet'
// msg
import { diffOfTwoObject } from '@/core/utils/common'
export default {
  name: 'PalletModify',
  mixins: [dialogMixin],
  components: {
    CommonDialog
  },
  props: {},
  data() {
    return {
      inputsMap: cloneDeep(Object.values(PalletInfoModifyForm)),
      originPallet: null,
      palletId: '',
      cb: undefined
    }
  },
  methods: {
    save(info, done, error) {
      // todo 需要检查 输入的东西是否正确
      info.addressId = info.address?.id
      let diffs = diffOfTwoObject(info, this.originPallet)
      diffs = Object.fromEntries(diffs.map(one => [one.key, one.newValue]))
      if ('address' in diffs) {
        diffs.addressId = diffs.address?.id ?? undefined
      }
      if (!isEmpty(diffs)) {
        modifyPallet(this.palletId, diffs).then(res => {
          this.$message.success('Modify pallet successfully!')
          this.close()
          done()
          if (this.cb) this.cb()
        })
      }
    },
    open(pallet, cb = undefined) {
      this.palletId = pallet.id
      this.$refs.dialog.open()
      this.originPallet = pallet
      this.resetInputs()
    },
    close() {
      this.originPallet = null
      this.$refs.dialog.close()
    },
    resetInputs() {
      this.inputsMap.forEach(one => {
        one.value = get(this.originPallet, one.key, '')
      })
    },
    valueChange() {}
  }
}
</script>
<style lang="scss" scoped>
@import '@/assets/styles/common.scss';
</style>
